/** True if the product has more than one size and/or alternative colors. */
export const canEditProductVariant = (product?: object | null): boolean => {
  if (!product) return true
  const { size, 'alternative-color': altColors } = product as {
    size?: ReadonlyArray<unknown> | null
    'alternative-color'?: ReadonlyArray<unknown> | null
  }
  return (size?.length ?? 0) > 1 || (altColors?.length ?? 0) > 0
}
